// Role helpers. The server checks every role. The console only hides forms a role cannot use.
import type { Role } from "../api/types";

const RANK: Record<Role, number> = { reader: 0, publisher: 1, admin: 2, owner: 3 };

/** True if `role` is `min` or higher. */
export function atLeast(role: Role, min: Role): boolean {
  return RANK[role] >= RANK[min];
}
